
      var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.406 8.906h15",
  stroke: "url(#plus_28b2f1f4c641a2f1__a)",
  strokeWidth: 2.813,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.906 16.406v-15",
  stroke: "url(#plus_28b2f1f4c641a2f1__b)",
  strokeWidth: 2.813,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "plus_28b2f1f4c641a2f1__a",
  x1: 2.813,
  y1: 11.406,
  x2: 16.584,
  y2: 6.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "plus_28b2f1f4c641a2f1__b",
  x1: 1.906,
  y1: 15,
  x2: 14.919,
  y2: -0.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M1.40625 8.90625H16.4062\" stroke=\"url(#paint0_linear_11049_30264)\" stroke-width=\"2.8125\" stroke-linecap=\"round\"/>\r\n<path d=\"M8.90625 16.4062L8.90625 1.40625\" stroke=\"url(#paint1_linear_11049_30264)\" stroke-width=\"2.8125\" stroke-linecap=\"round\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_11049_30264\" x1=\"2.8125\" y1=\"11.4062\" x2=\"16.5835\" y2=\"6.95443\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint1_linear_11049_30264\" x1=\"1.90625\" y1=\"15\" x2=\"14.9189\" y2=\"-0.367307\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/plus.28b2f1f4c641a2f13ccb2727e6d4d562.svg"),
        {
          React: SvgPlus,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      